import styled from 'styled-components'
import tw, { screen } from 'twin.macro'

export const RootWithHeader = styled.div`
  display: grid;
  ${tw`w-full`};

  grid-template-areas:
    'header header'
    'filter sort'
    'products products';
  grid-template-columns: repeat(2, 1fr);
  ${tw`gap-x-6`};

  @media (min-width: 62rem) {
    grid-template-areas:
      'header header sort'
      'filter products products';
    grid-template-columns: 16rem auto 10rem;
  }
`

export const RootWithoutHeader = styled.div`
  display: grid;
  ${tw`w-full`};

  grid-template-areas:
    'filter sort'
    'products products';
  grid-template-columns: repeat(2, 1fr);
  ${tw`gap-x-6`};

  @media (min-width: 62rem) {
    grid-template-areas:
      'empty empty sort'
      'filter products products';
    grid-template-columns: 16rem auto 10rem;
  }
`

export const Header = styled.div`
  grid-area: header;
  ${tw`pb-6 lg:pb-12 mb-6`}
  border-bottom: 1px solid var(--color-grey);
`

export const Sort = styled.div`
  grid-area: sort;
  align-self: end;
  ${tw`pb-6 lg:pb-12 lg:mb-6`}
  ${screen`lg`({ borderBottom: '1px solid var(--color-grey)' })};
`

export const Filter = styled.div`
  ${screen`lg`({
    gridArea: 'filter',
    ...tw`sticky h-full`,
  })};
  ${tw`mb-6 lg:mb-0 lg:pr-6 lg:mr-6 lg:border-r`}
  ${screen`lg`({ maxHeight: 'calc(100vh - var(--nav-height))', overflowY: 'auto' })};
  top: var(--nav-height);
  border-color: var(--color-grey);

  &::-webkit-scrollbar {
    width: 0.25rem;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--color-gold-lightest);
  }
`

export const Products = styled.div`
  grid-area: products;
  /* min-height: 2000px; */
`

export const StatusBar = styled.div`
  ${tw`flex justify-between items-center mb-6`}
`
